import { makeStyles } from '@material-ui/core';

export const styles = () => {
  return makeStyles((theme) => ({
    root: {
      padding: 20
    },
    multilineColor: {
      color: theme.palette.text.secondary
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: '100%'
    },
    titleGrid: {
      paddingTop: 15,
      paddingLeft: 35
    },
    bt_confirmar: {
      width: '100%'
    },
    footer: {
      padding: 20
    },
    dateLabel: {
      textAlign: 'center'
    }
  }));
};
